import axios, { AxiosResponse } from "axios";
import getConfig from "../config/configUtil";
import { WorktimeSchedule } from "../models/worktimeSchedule";

const conf = getConfig;

class WorktimeService {
  async getWorktimes(): Promise<WorktimeSchedule> {
    try {
      const response: AxiosResponse = await axios.get(conf.BACKEND + "worktime/get");
      return response.data;
    } catch (error) {
      console.log(error);
      throw new Error("Failed to fetch Worktimes");
    }
  }
}

export default WorktimeService;
